import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  Grid,
  Input,
  Button,
  ControlLabel,
  RadioGroup,
  Radio,
  Icon,
  IconButton,
  SelectPicker,
  Message,
  Checkbox,
  Modal,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  saveDraftProposeConsiderApproveProject,
  saveProposeConsiderApproveProject,
  updateDraftProposeConsiderApproveProject,
  updateProposeConsiderApproveProject,
  rejectApproval,
  getApproverList,
} from '../../redux/actions/proposeConsiderApproveProject'
import { useHistory, useParams } from 'react-router-dom'
import { startLoading, doneLoading } from '../../utils/loading'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import classNames from 'classnames'
import InputForm from '../../components/forms/input/InputForm'
import CustomAlertMessageInfo from '../CustomAlertMessageInfo'
import { Link } from 'react-router-dom'
import CoiApproveProjectWidget from '../coi/CoiApproveProjectWidget'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { getProjectReview } from '../../redux/actions/reviewSummary'
import { cloneDeep } from 'lodash-es'
import ShowLimitLength from '../../components/utils/ShowLimitLength'
import ApproverDetailWidgets from '../../widgets/ApproverDetail/ApproverDetailWidgets'
import COIValidateWidget from '../coi/COIValidateWidget'
import ApproverListWidget from '../ApproverDetail/ApproverListWidget'
import ApproverTable from '../ApproverDetail/ApproverTable'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import { getFetchNew } from '../../redux/actions/approveProject'
import notification from '../../utils/notification'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'
export default function ProposeConsiderApproveProjectWidget(props) {
  const {
    showCommandButton,
    onSuccess = () => {},
    disabled,
    onEnableForm,
    isConfirmEbudget,
    attachFilesSchema,
    isApproveByContractCenter,
    isContractCenter,
  } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [schema, setFormSchema] = useState(props.schema)
  const [hideHead, setHideHead] = useState(props.hideHead)
  const [hideSubmit, setHideSubmit] = useState(props.hideSubmit)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [contractSignType, setContractSignType] = useState(
    schema.contractSignType.value ? parseInt(schema.contractSignType.value) : 0
  )
  const [thaiHealthWitnessList, setThaiHealthWitnessList] = useState([])
  const [granteeWitnessList, setGranteeWitnessList] = useState([])
  const [isShowConfimPullBackModal, setIsShowConfimPullBackModal] = useState(false)
  const [isCheckCOI, setIsCheckCOI] = useState(false)
  const [isCOIPass, setIsCOIPass] = useState(false)
  const [checkCOI, setCheckCOI] = useState(false)
  const [checkInterest, setCheckInterest] = useState(false)
  const [showCOIDetail, setShowCOIDetail] = useState(false)
  const [filesList, setFilesList] = useState([])
  const [isErrorNotValidateFiles, setIsErrorNotValidateFiles] = useState(false)
  const [isSaveDraft, setIsSaveDraft] = useState(false)
  const [isSaveDraftSuccess, setIsSaveDraftSuccess] = useState(false)
  const [inputNote, setInputNote] = useState()
  const [getInputNoteError, setGetInputNoteError] = useState(false)
  const [commentType, setCommentType] = useState(0)
  const [commentLabel, setCommentLabel] = useState('')
  const [reason, setReason] = useState('')
  const [reasonTextLength, setReasonTextLength] = useState(0)
  const [isShowApproverList, setIsShowApproverList] = useState(false)
  const [ApproverLists, setApproverLists] = useState([])
  const [getApproverListError, setGetApproverListError] = useState(false)
  const [showApproversDetail, setShowApproversDetail] = useState(false)
  const [approverDatas, setApproverDatas] = useState()

  useEffect(() => {
    if (attachFilesSchema) {
      setFilesList(attachFilesSchema?.attachFiles?.value || [])
    }
  }, [attachFilesSchema])

  useEffect(() => {
    let arr = schema?.thaiHealthWitness?.values || []
    //console.log('schema.thaiHealthWitness', arr)

    if (
      schema?.thaiHealthWitness?.firstName?.value &&
      schema?.thaiHealthWitness?.lastName?.value &&
      schema?.thaiHealthWitness?.honorific?.value
    ) {
      let newList = [
        {
          honorific: schema?.thaiHealthWitness?.honorific?.value,
          firstName: schema?.thaiHealthWitness?.firstName?.value,
          lastName: schema?.thaiHealthWitness?.lastName?.value,
        },
      ]
      setThaiHealthWitnessList(newList)
      // if (arr.length > 0) {
      // let newList = sortByMainPersonFirst(arr)
      // console.log('newList', newList)
      //setThaiHealthWitnessList(arr)
    } else {
      let initialList = [{ honorific: '', firstName: '', lastName: '' }]
      setThaiHealthWitnessList(initialList)
    }
  }, [schema?.thaiHealthWitness])

  useEffect(() => {
    let arr = schema?.granteeWitness?.values || []
    //console.log('schema.granteeWitness', arr)
    if (
      schema?.granteeWitness?.firstName?.value &&
      schema?.granteeWitness?.lastName?.value &&
      schema?.granteeWitness?.honorific?.value
    ) {
      let newList = [
        {
          honorific: schema?.granteeWitness?.honorific?.value,
          firstName: schema?.granteeWitness?.firstName?.value,
          lastName: schema?.granteeWitness?.lastName?.value,
        },
      ]
      setGranteeWitnessList(newList)
      // if (arr.length > 0) {
      // let newList = sortByMainPersonFirst(arr)
      // console.log('newList', newList)
      // setGranteeWitnessList(arr)
    } else {
      let initialList = [{ honorific: '', firstName: '', lastName: '' }]
      setGranteeWitnessList(initialList)
    }
  }, [schema?.granteeWitness])

  const handleCallService = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsSaveDraftSuccess(false)
    try {
      let response
      console.log('request:', JSON.stringify(request))
      if (request.id) {
        console.log('call update.')
        if (isSaveDraft) {
          response = await updateDraftProposeConsiderApproveProject(id, request)
        } else {
          response = await updateProposeConsiderApproveProject(id, request)
        }
      } else {
        console.log('call save.')
        if (isSaveDraft) {
          response = await saveDraftProposeConsiderApproveProject(id, request)
        } else {
          response = await saveProposeConsiderApproveProject(id, request)
        }
      }

      if (isSaveDraft) {
        setFormSchema(response?.forms)
        setIsSaveDraftSuccess(true)
        setIsSaveDraft(false)
        setTimeout(() => {
          setIsSaveDraftSuccess(false)
        }, 3000)
      } else {
        doneLoading()
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallGetProjectReview = async () => {
    startLoading()
    setGetInputNoteError('')
    setIsLoading(true)
    try {
      let response = await getProjectReview(projectId)
      // console.log(response?.data?.descriptionSummary)
      setInputNote(response?.data?.descriptionSummary)
    } catch (e) {
      // console.log(e)
      setGetInputNoteError(
        'เกิดข้อผิดพลาดในการดึงข้อมุลสรุปผลการกลั่นกรอง กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'
      )
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallServicePullBack = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await rejectApproval(id, request)

      if (response) {
        setIsShowConfimPullBackModal(false)
        doneLoading()
        setIsLoading(false)
        window.location.reload()
        //return history.push(`${pathname.proposal.approve.ProposeConsiderApproveProject}/${projectId}`)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsShowConfimPullBackModal(false)
    setIsLoading(false)
    doneLoading()
  }

  const handleCallServiceVerifyApprover = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response = await getApproverList(projectId)
      if (response?.values) {
        setApproverLists(response?.values)
      }
      setIsShowApproverList(true)
    } catch (e) {
      setIsError(true)
    }
    setIsShowConfimPullBackModal(false)
    setIsLoading(false)
    doneLoading()
  }

  const handleOnConfirmPullBackModal = (data) => {
    console.log('data', data)
    // onEnableForm()

    let request = {
      projectVersionId: projectId,
      reason: data.reason,
      commentType: commentType,
    }
    handleCallServicePullBack(projectId, request)
  }

  const onSubmitDraft = (data) => {
    setIsSaveDraft(true)
    // onSubmitValidate(data)
    setIsShowConfimModal(true)
  }

  const onSubmit = (data) => {
    setIsSaveDraft(false)
    onSubmitValidate(data)
  }

  const onSubmitValidate = (data) => {
    // console.log('filesList', filesList)

    //check is validate all file require
    if (filesList.length > 0) {
      setIsErrorNotValidateFiles('')
      var requiredList = filesList.filter((item) => item.isRequired)
      console.log('requiredList', requiredList)

      if (requiredList.length > 0) {
        var isValid = true
        requiredList.forEach((item, index) => {
          if (!item.isValidated || !item.path) {
            setIsErrorNotValidateFiles(
              'กรุณาแนบไฟล์คุณสมบัติผู้รับทุน และบันทึกตรวจสอบไฟล์ ให้ครบถ้วน'
            )
            isValid = false
          }
        })

        if (!isValid) return
      }
    }

    setIsShowConfimModal(true)
  }

  const handleOnConfirmModal = (data) => {
    console.log('data', data)

    let _thaiHealthWitness = thaiHealthWitnessList.map((item, index) => {
      item.honorific =
        data[schema.thaiHealthWitness?.honorific?.name + '_' + 'Thaihealth' + '_' + index]
      item.firstName =
        data[schema.thaiHealthWitness?.firstName?.name + '_' + 'Thaihealth' + '_' + index]
      item.lastName =
        data[schema.thaiHealthWitness?.lastName?.name + '_' + 'Thaihealth' + '_' + index]
      return item
    })

    let _granteeWitness = granteeWitnessList.map((item, index) => {
      item.honorific = data[schema.granteeWitness?.honorific?.name + '_' + 'Grantee' + '_' + index]
      item.firstName = data[schema.granteeWitness?.firstName?.name + '_' + 'Grantee' + '_' + index]
      item.lastName = data[schema.granteeWitness?.lastName?.name + '_' + 'Grantee' + '_' + index]
      return item
    })

    console.log('_thaiHealthWitness', _thaiHealthWitness)
    console.log('_granteeWitness', _granteeWitness)

    let request = {
      id: schema.inputNote.id,
      value: data.note,
      contractsignType: data.contractsignType,
      valueToReport: data.noteToReport,
      isCOI: checkInterest,
      thaiHealthWitnessHonorific: _thaiHealthWitness[0].honorific || '',
      thaiHealthWitnessFirstName: _thaiHealthWitness[0].firstName || '',
      thaiHealthWitnessLastName: _thaiHealthWitness[0].lastName || '',
      granteeWitnessHonorific: _granteeWitness[0].honorific || '',
      granteeWitnessFirstName: _granteeWitness[0].firstName || '',
      granteeWitnessLastName: _granteeWitness[0].lastName || '',
    }

    // console.log('request', request)

    setIsShowConfimModal(false)
    handleCallService(projectId, request)
  }

  const handlePlusThaiHealthWitness = () => {
    let arr = [...thaiHealthWitnessList]
    arr.push({ honorific: '', firstName: '', lastName: '' })
    setThaiHealthWitnessList(arr)
  }

  const handleDeleteThaiHealthWitness = (index) => {
    let arr = [...thaiHealthWitnessList]
    // console.log('arr', arr, 'index', index)
    arr.splice(index, 1)
    setThaiHealthWitnessList(arr)
  }

  const handlePlusGranteeWitness = () => {
    let arr = [...granteeWitnessList]
    arr.push({ honorific: '', firstName: '', lastName: '' })
    setGranteeWitnessList(arr)
  }

  const handleDeleteGranteeWitness = (index) => {
    let arr = [...granteeWitnessList]
    // console.log('arr', arr, 'index', index)
    arr.splice(index, 1)
    setGranteeWitnessList(arr)
  }

  const renderThaiHealthWitness = thaiHealthWitnessList.map((item, index) => {
    return (
      <Row key={index}>
        <Col xs={24} sm={8} md={4} lg={4} style={{ marginTop: 35, width: 70 }}>
          {/* {index == 0 ? 'ผู้ลงนามหลัก' : 'ผู้ลงนามร่วม'} */}
          <span>พยาน {index + 1}</span>
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema.thaiHealthWitness?.honorific?.validators) && 'required'
            )}
          >
            {schema.thaiHealthWitness?.honorific?.label}
          </ControlLabel>
          <ErrorMessage
            error={
              errors[schema.thaiHealthWitness?.honorific?.name + '_' + 'Thaihealth' + '_' + index]
            }
          />
          <Controller
            name={schema.thaiHealthWitness?.honorific?.name + '_' + 'Thaihealth' + '_' + index}
            control={control}
            defaultValue={item.honorific}
            rules={isValidators(schema.thaiHealthWitness?.honorific?.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={
                    schema.thaiHealthWitness?.honorific?.options ||
                    thaiHealthWitness.honorific.options
                  }
                  value={props.value}
                  style={{ width: '100%' }}
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                  disabled={!showCommandButton}
                />
              )
            }}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema.thaiHealthWitness?.firstName?.validators) && 'required'
            )}
          >
            {schema.thaiHealthWitness?.firstName?.label}
          </ControlLabel>
          <ErrorMessage
            error={
              errors[schema.thaiHealthWitness?.firstName?.name + '_' + 'Thaihealth' + '_' + index]
            }
          />
          <Input
            placeholder={schema.thaiHealthWitness?.firstName?.label}
            defaultValue={item.firstName}
            name={schema.thaiHealthWitness?.firstName?.name + '_' + 'Thaihealth' + '_' + index}
            inputRef={register(isValidators(schema.thaiHealthWitness?.firstName?.validators))}
            disabled={!showCommandButton}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema.thaiHealthWitness?.lastName?.validators) && 'required'
            )}
          >
            {schema.thaiHealthWitness?.lastName?.label}
          </ControlLabel>
          <ErrorMessage
            error={
              errors[schema.thaiHealthWitness?.lastName?.name + '_' + 'Thaihealth' + '_' + index]
            }
          />
          <Input
            placeholder={schema.thaiHealthWitness?.lastName?.label}
            defaultValue={item.lastName}
            name={schema.thaiHealthWitness?.lastName?.name + '_' + 'Thaihealth' + '_' + index}
            inputRef={register(isValidators(schema.thaiHealthWitness?.lastName?.validators))}
            disabled={!showCommandButton}
          />
        </Col>
        {index >= 1 && (
          <Col xs={4} sm={4} md={3} lg={3} style={{ marginTop: 32, width: 50 }}>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={<Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />}
              onClick={() => handleDeleteThaiHealthWitness(index)}
              style={{ marginLeft: 5 }}
              disabled={!showCommandButton}
            ></IconButton>
          </Col>
        )}

        {thaiHealthWitnessList.length - 1 === index && (
          <Col xs={4} sm={4} md={4} lg={4} style={{ marginTop: 32, width: 50 }}>
            {/* <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
              onClick={() => handlePlusThaiHealthWitness()}
            >
              เพิ่ม{schema.thaiHealthWitness?.buttonText}
            </IconButton> */}
          </Col>
        )}
      </Row>
    )
  })

  const renderGranteeWitness = granteeWitnessList.map((item, index) => {
    return (
      <Row key={index}>
        <Col xs={24} sm={8} md={4} lg={4} style={{ marginTop: 35, width: 70 }}>
          {/* {index == 0 ? 'ผู้ลงนามหลัก' : 'ผู้ลงนามร่วม'} */}
          <span>พยาน {index + 1}</span>
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema.granteeWitness?.honorific?.validators) && 'required'
            )}
          >
            {schema.granteeWitness?.honorific?.label}
          </ControlLabel>
          <ErrorMessage
            error={errors[schema.granteeWitness?.honorific?.name + '_' + 'Grantee' + '_' + index]}
          />
          <Controller
            name={schema.granteeWitness?.honorific?.name + '_' + 'Grantee' + '_' + index}
            control={control}
            defaultValue={item.honorific}
            rules={isValidators(schema.granteeWitness?.honorific?.validators)}
            render={(props) => {
              return (
                <SelectPicker
                  data={
                    schema.granteeWitness?.honorific?.options || granteeWitness.honorific.options
                  }
                  value={props.value}
                  style={{ width: '100%' }}
                  placeholder="เลือก"
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                  disabled={!showCommandButton}
                />
              )
            }}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema.granteeWitness?.firstName?.validators) && 'required'
            )}
          >
            {schema.granteeWitness?.firstName?.label}
          </ControlLabel>
          <ErrorMessage
            error={errors[schema.granteeWitness?.firstName?.name + '_' + 'Grantee' + '_' + index]}
          />
          <Input
            placeholder={schema.granteeWitness?.firstName?.label}
            defaultValue={item.firstName}
            name={schema.granteeWitness?.firstName?.name + '_' + 'Grantee' + '_' + index}
            inputRef={register(isValidators(schema.granteeWitness?.firstName?.validators))}
            disabled={!showCommandButton}
          />
        </Col>
        <Col xs={24} sm={8} md={5} lg={5} style={{ marginTop: '10px' }}>
          <ControlLabel
            className={classNames(
              'style-text-lable',
              isRequired(schema.granteeWitness?.lastName?.validators) && 'required'
            )}
          >
            {schema.granteeWitness?.lastName?.label}
          </ControlLabel>
          <ErrorMessage
            error={errors[schema.granteeWitness?.lastName?.name + '_' + 'Grantee' + '_' + index]}
          />
          <Input
            placeholder={schema.granteeWitness?.lastName?.label}
            defaultValue={item.lastName}
            name={schema.granteeWitness?.lastName?.name + '_' + 'Grantee' + '_' + index}
            inputRef={register(isValidators(schema.granteeWitness?.lastName?.validators))}
            disabled={!showCommandButton}
          />
        </Col>
        {index >= 1 && (
          <Col xs={4} sm={4} md={3} lg={3} style={{ marginTop: 32, width: 50 }}>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={<Icon appearance="ghost" icon="trash" className="bt-gost-icon-radius-cancel" />}
              onClick={() => handleDeleteGranteeWitness(index)}
              style={{ marginLeft: 5 }}
              disabled={!showCommandButton}
            ></IconButton>
          </Col>
        )}

        {granteeWitnessList.length - 1 === index && (
          <Col xs={4} sm={4} md={4} lg={4} style={{ marginTop: 32, width: 50 }}>
            {/* <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
              onClick={() => handlePlusGranteeWitness()}
            >
              เพิ่ม{schema.granteeWitness?.buttonText}
            </IconButton> */}
          </Col>
        )}
      </Row>
    )
  })

  return (
    <>
      <Panel header={schema.header} collapsible defaultExpanded bordered shaded>
        {schema.contractSignType && (
          <Row>
            {schema.contractSignType?.descriptions && (
              <CustomAlertMessageInfo contents={schema.contractSignType.descriptions} />
            )}
            <ErrorMessage error={errors[schema.contractSignType.name]} />
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <ControlLabel className="required">{schema.contractSignType.label}</ControlLabel>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <Controller
                key={schema.contractSignType.name}
                name={schema.contractSignType.name}
                control={control}
                rules={isValidators(schema.contractSignType.validators)}
                defaultValue={
                  schema.contractSignType.value ? parseInt(schema.contractSignType.value) : null
                }
                render={(props) => {
                  return (
                    <RadioGroup
                      value={props.value}
                      onChange={(value) => {
                        props.onChange(value)
                        setContractSignType(value)
                      }}
                    >
                      {schema.contractSignType?.options?.map((item, index) => {
                        return (
                          <Radio value={item.value} key={index} disabled={!showCommandButton}>
                            {item.label}{' '}
                          </Radio>
                        )
                      })}
                    </RadioGroup>
                  )
                }}
              />
            </Col>
          </Row>
        )}
        <br />
        {contractSignType == 2 && (
          <>
            <div>
              {schema.thaiHealthWitness && (
                <>
                  <span>{schema.thaiHealthWitness.header || thaiHealthWitness.header}</span>
                  <Row>
                    {renderThaiHealthWitness}

                    {thaiHealthWitnessList.length === 0 && (
                      <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 34, width: 50 }}>
                        <IconButton
                          appearance="ghost"
                          icon={
                            <Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />
                          }
                          onClick={() => handlePlusThaiHealthWitness()}
                          disabled={!showCommandButton}
                        >
                          เพิ่ม{schema.thaiHealthWitness.buttonText || thaiHealthWitness.buttonText}
                        </IconButton>
                      </Col>
                    )}
                  </Row>
                  <br />
                </>
              )}
            </div>

            <br />

            <div>
              {schema.granteeWitness && (
                <>
                  <span>{schema.granteeWitness.header || granteeWitness.header}</span>
                  <Row>
                    {renderGranteeWitness}

                    {granteeWitnessList.length === 0 && (
                      <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 34, width: 50 }}>
                        <IconButton
                          appearance="ghost"
                          icon={
                            <Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />
                          }
                          onClick={() => handlePlusGranteeWitness()}
                          disabled={!showCommandButton}
                        >
                          เพิ่ม{schema.granteeWitness.buttonText || granteeWitness.buttonText}
                        </IconButton>
                      </Col>
                    )}
                  </Row>
                  <br />
                </>
              )}
            </div>
          </>
        )}

        <InputForm
          schema={schema.inputNoteToReport}
          placeholder={schema.inputNoteToReport.plachoderText}
          rows={5}
          componentClass="textarea"
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          disabled={!showCommandButton}
        />
        <br />

        {schema.inputNote && (
          <>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-info"
              style={{ marginRight: '8px' }}
              icon={<Icon className="bt-gost-icon-radius-info" icon="refresh2" />}
              disabled={disabled || !showCommandButton}
              onClick={() => {
                handleCallGetProjectReview()
              }}
            >
              ใช้ข้อมูลสรุปผลกลั่นกรอง
            </IconButton>
            {getInputNoteError && (
              <Message
                showIcon
                type="error"
                style={{ marginTop: 10 }}
                description={getInputNoteError}
                closable
                onClose={() => {
                  setGetInputNoteError('')
                }}
              />
            )}
          </>
        )}

        <InputForm
          schema={schema.inputNote}
          placeholder={schema.inputNote.plachoderText}
          rows={5}
          componentClass="textarea"
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          disabled={!showCommandButton}
          value={inputNote}
          onChange={(value) => {
            setInputNote(value)
          }}
        />

        {/* <ControlLabel>
          {requiredFiled(schema.inputNote.validators, schema.inputNote.label)}
        </ControlLabel>
        <ErrorMessage error={errors[schema.inputNote.name]} />
        <br />
        <Input
          name={schema.inputNote.name}
          inputRef={register(isValidators(schema.inputNote.validators))}
          rows={3}
          placeholder={schema.inputNote.plachoderText}
          componentClass="textarea"
          defaultValue={schema.inputNote.value}
        /> */}

        {/* <ControlLabel>
          {requiredFiled(schema.inputNoteToReport.validators, schema.inputNoteToReport.label)}
        </ControlLabel>
        <ErrorMessage error={errors[schema.inputNoteToReport.name]} />
        <br />
        <Input
          name={schema.inputNoteToReport.name}
          inputRef={register(isValidators(schema.inputNoteToReport.validators))}
          rows={3}
          placeholder={schema.inputNoteToReport.plachoderText}
          componentClass="textarea"
          defaultValue={schema.inputNoteToReport.value}
        /> */}

        {showCommandButton ? (
          <>
            {/*check coi ยืนยันไม่มีส่วนได้เสีย*/}
            {isConfirmEbudget && isApproveByContractCenter && !schema?.isBudgetYearNotMatch && (
              <COIValidateWidget
                disabled={disabled || !showCommandButton}
                isCOIPass={isCOIPass}
                setIsCOIPass={setIsCOIPass}
                checkCOI={checkCOI}
                setCheckCOI={setCheckCOI}
                setIsCheckCOI={setIsCheckCOI}
                setCheckInterest={setCheckInterest}
                checkInterest={checkInterest}
                fixType={'7'}
              />
            )}

            <hr />

            {schema?.isBudgetYearNotMatch && (
              <Message
                showIcon
                type="error"
                description={
                  <div>
                    <span>กรุณาบันทึกแผนงบประมาณใหม่ เนื่องจากปีงบประมาณไม่ถูกต้อง &nbsp;</span>
                    <Link
                      to={{
                        pathname: `${pathname.proposal.review.paymentSave}`,
                      }}
                      onClick={() => {
                        sessionStorage.setItem('projectId', projectId)
                        sessionStorage.setItem('param', '')
                      }}
                    >
                      <u>ไปหน้าบันทึกแผนงบประมาณ</u>
                    </Link>
                    <span>&nbsp;เพื่อบันทึกแผนงบประมาณใหม่</span>
                  </div>
                }
              />
            )}

            {!isConfirmEbudget && (
              <Message
                showIcon
                type="error"
                description={
                  <div>
                    <span>กรุณายืนยันงบประมาณก่อนส่งเสนอพิจารณาอนุมัติทุนโครงการ &nbsp;</span>
                    <Link
                      to={{
                        pathname: `${pathname.proposal.approve.paymentCheck}`,
                      }}
                      onClick={() => {
                        sessionStorage.setItem('projectId', projectId)
                        sessionStorage.setItem('param', '')
                      }}
                    >
                      <u>ไปหน้าขั้นที่ 1 ตรวจสอบงวดเงิน</u>
                    </Link>
                    <span>&nbsp;เพื่อยืนยันงบประมาณ</span>
                  </div>
                }
              />
            )}

            {!isApproveByContractCenter && (
              <Message
                showIcon
                type="error"
                description={
                  <div>
                    <span>ต้องได้รับการตรวจสอบจากศูนย์สัญญา ก่อนส่งเสนออนุมัติโครงการ &nbsp;</span>
                    {/* <Link
                      to={{
                        pathname: `${pathname.proposal.approve.paymentCheck}/${projectId}`,
                        // search: `?${schema.requestId}`,
                      }}
                    >
                      <u>ไปหน้าขั้นที่ 1 ตรวจสอบงวดเงิน</u>
                    </Link>
                    <span>&nbsp;เพื่อยืนยันงบประมาณ</span> */}
                  </div>
                }
                style={{ marginBottom: 10 }}
              />
            )}

            {isErrorNotValidateFiles && (
              <Message
                showIcon
                type="error"
                description={isErrorNotValidateFiles}
                style={{ marginBottom: 10 }}
              />
            )}

            {isSaveDraftSuccess && (
              <Message
                showIcon
                type="success"
                description="บันทึกร่างสำเร็จ"
                style={{ marginBottom: 10 }}
              />
            )}

            

            <SaveButton
              style={{ marginRight: 20 }}
              onClick={handleSubmit(onSubmitDraft)}
              disabled={(isLoading || disabled || !showCommandButton) && !isCOIPass}
            >
              บันทึกร่าง
            </SaveButton>

            {/* <SaveButton
              style={{ marginRight: 20 }}
              onClick={handleCallServiceVerifyApprover}
              disabled={isLoading || disabled || !showCommandButton}
            >
              ตรวจสอบสายอนุมัติ
            </SaveButton> */}
            <ApproverList
              approveType={2}
              projectversionId={projectId}
              disabled={
                schema?.isBudgetYearNotMatch ||
                !schema.isApproveByContractCenter ||
                isLoading ||
                disabled ||
                !showCommandButton ||
                !isConfirmEbudget ||
                !checkCOI ||
                !isCOIPass
              }
              buttontext={"ตรวจสอบสายอนุมัติและ" + schema.buttonText}
              isLoading={isLoading}
              fetchButton={(disabled) =>
                <Button
                  // style={{ width: 160 }}
                  // appearance="ghost"
                  style={{ marginRight: 20, marginBottom: 10 }}
                  color="rgb(45, 168, 136)"
                  appearance="primary"
                  onClick={handleSubmit(onSubmit)}
                  disabled={
                    schema?.isBudgetYearNotMatch ||
                    !schema.isApproveByContractCenter ||
                    isLoading ||
                    disabled ||
                    !showCommandButton ||
                    !isConfirmEbudget ||
                    !checkCOI ||
                    !isCOIPass ||
                    disabled
                  }
                >
                  {schema.buttonText}
                </Button>
              }
            />
          </>
        ) : isContractCenter ? (
          <></>
        ) : (
          <>
            <hr />
            {/* <Button
              style={{ marginRight: 10 }}
              // appearance="ghost"
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={() => {
                setIsShowConfimPullBackModal(true)
                setCommentType(2)
                setCommentLabel('ดึงรายงานเสนออนุมัติโครงการกลับเพื่อขอเสนออนุมัติใหม่')
                setReason('')
                setReasonTextLength(0)
                clearErrors('reason')
              }}
              disabled={isLoading}
            >
              {'ดึงรายงานเสนออนุมัติโครงการกลับเพื่อขอเสนออนุมัติใหม่'}
            </Button>

            <Button
              // style={{ width: 160 }}
              // appearance="ghost"
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={() => {
                setIsShowConfimPullBackModal(true)
                setCommentType(3)
                setCommentLabel('ยกลิกคำขอเสนออนุมัติ')
                setReason('')
                setReasonTextLength(0)
                clearErrors('reason')
              }}
              disabled={isLoading}
            >
              {'ยกลิกคำขอเสนออนุมัติ'}
            </Button> */}

            {schema.checkButton && (
              <ApproverList
                approveType={2}
                projectversionId={projectId}
                style={{ marginRight: 10 }}
                buttontext={schema.checkButton}
                isLoading={isLoading}
                fetchButton={(disabled) =>
                  schema.fetchButton && <FetchNewApprover
                    approveType={2}
                    projectversionId={projectId}
                    style={{ marginRight: 10, marginBottom: 10 }}
                    buttontext={schema?.fetchButton}
                    onSuccess={onSuccess}
                    disabled={disabled}
                    />
                }
              />
            )}

            {schema.cancelButton && (
              <CancelApprovalList
                approveType={2}
                projectversionId={projectId}
                style={{ marginRight: 10 }}
                buttontext={schema.cancelButton}
                onSuccess={onSuccess}
              />
            )}
          </>
        )}
        <ConfirmWidget
          title={`ยืนยันการ${isSaveDraft ? 'บันทึกร่าง' : schema.buttonText}`}
          show={isShowConfimModal}
          detail={`กรุณายืนยันการ${isSaveDraft ? 'บันทึกร่าง' : schema.buttonText}`}
          onCancle={() => {
            setIsSaveDraft(false)
            setIsShowConfimModal(false)
          }}
          onConfirm={handleSubmit(handleOnConfirmModal)}
        />
        <Modal
          backdrop={'static'}
          size={'md'}
          show={isShowConfimPullBackModal}
          onHide={() => setIsShowConfimPullBackModal(false)}
          //onShow={handleOnShow}
        >
          <Modal.Header>
            <Modal.Title>
              <p style={{ paddingTop: '0.5rem' }}>{`ยืนยันการ${commentLabel}`}</p>
            </Modal.Title>
          </Modal.Header>
          <br />
          <ControlLabel>
            {requiredFiled(
              [
                {
                  type: 'REQUIRED',
                },
              ],
              `ระบุเหตุผลการ${commentLabel}`
            )}
          </ControlLabel>

          <ErrorMessage error={errors?.reason} />
          <Input
            name={'reason'}
            componentClass="textarea"
            rows={5}
            placeholder={'ระบุเหตุผล' + commentLabel}
            inputRef={register(
              isValidators([
                {
                  type: 'REQUIRED',
                  value: null,
                  errorMessage: 'กรุณาระบุเหตุผล' + commentLabel,
                },
              ])
            )}
            maxLength={255}
            defaultValue={reason}
            value={reason}
            onChange={(value) => {
              setReason(value)
              setReasonTextLength(value.length)
              setValue('reason', value)
            }}
          />
          <ShowLimitLength textLength={reasonTextLength} maxLength={255} />
          <br />
          <Modal.Footer>
            <div>
              <Button
                onClick={handleSubmit(handleOnConfirmPullBackModal)}
                ripple
                appearance="primary"
                loading={isLoading}
              >
                {'ยืนยัน'}
              </Button>
              <Button
                onClick={() => setIsShowConfimPullBackModal(false)}
                ripple
                appearance="subtle"
              >
                {'ยกเลิก'}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal
          backdrop={'static'}
          //size={'lg'}
          full
          show={isShowApproverList}
          onHide={() => setIsShowApproverList(false)}
          //onShow={handleOnShow}
        >
          <ApproverDetailWidgets dataList={ApproverLists} header={'รายชื่อสายอนุมัติ'} />
          <Modal.Footer>
            <div>
              <hr />
              <Button onClick={() => setIsShowApproverList(false)} ripple appearance="subtle">
                {'ปิด'}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      </Panel>
    </>
  )
}

const thaiHealthWitness = {
  header: 'พยานฝั่งสสส.',
  buttonText: 'พยานฝั่งสสส.',
  values: [],
  honorific: {
    optionSelected: null,
    options: [
      {
        label: 'นาย',
        value: '29DB8384-9123-4D4E-96FF-BAB67EC7FCD9',
      },
      {
        label: 'นาง',
        value: '282C1F1B-B8FF-4163-A36C-1816067EFFDE',
      },
      {
        label: 'นางสาว',
        value: '3C77200E-7111-4653-9763-5224B0B19648',
      },
    ],
    name: 'honorific',
    label: 'คำนำหน้า',
    value: '',
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณาเลือกคำนำหน้า',
      },
    ],
  },
  firstName: {
    name: 'firstName',
    label: 'ชื่อ',
    value: '',
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณาระบุชื่อ',
      },
    ],
  },
  lastName: {
    name: 'lastName',
    label: 'สกุล',
    value: '',
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณาระบุนามสกุล',
      },
    ],
  },
}

const granteeWitness = {
  header: 'พยานฝั่งผู้รับทุน',
  buttonText: 'พยานฝั่งผู้รับทุน',
  values: [],
  honorific: {
    optionSelected: null,
    options: [
      {
        label: 'นาย',
        value: '29DB8384-9123-4D4E-96FF-BAB67EC7FCD9',
      },
      {
        label: 'นาง',
        value: '282C1F1B-B8FF-4163-A36C-1816067EFFDE',
      },
      {
        label: 'นางสาว',
        value: '3C77200E-7111-4653-9763-5224B0B19648',
      },
    ],
    name: 'honorific',
    label: 'คำนำหน้า',
    value: '',
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณาเลือกคำนำหน้า',
      },
    ],
  },
  firstName: {
    name: 'firstName',
    label: 'ชื่อ',
    value: '',
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณาระบุชื่อ',
      },
    ],
  },
  lastName: {
    name: 'lastName',
    label: 'สกุล',
    value: '',
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณาระบุนามสกุล',
      },
    ],
  },
}
